module.exports = __webpack_public_path__ + "static/media/search.b45d2695.svg";